import web from "../src/images/lm1.jpg"
import App from "../src/images/App1.jpg"
import Andriod from "../src/images/And1.jpg"
import Digital from "../src/images/Dg1.jpg"
import Marketing from "../src/images/Mrk1.jpg"
import Software from "../src/images/Sft1.jpg"
const Sdata =[
    {
        imgsrc: web,
        title:"Web Development"
    },
    {
        imgsrc:App,
        title:"App Development"
    },
    {
        imgsrc:Andriod,
        title:"Andriod Development"
    },
    {
        imgsrc:Digital,
        title:"digital Development"
    },
    {
        imgsrc:Marketing,
        title:"marketing Development"
    },
    {
        imgsrc:Software,
        title:"software Development"
    },
]

export default Sdata